import store from '@/state/store';
import { list } from '@/api/invitation';
import { handleError } from '@/actions/common';
import authenticationSlice from '@/state/authentication.slice';

export default async function (): Promise<void> {
  try {
    const invitations = await list();
    store.dispatch(authenticationSlice.actions.setInvitations(invitations));
  } catch (error) {
    handleError(error);
    throw error;
  }
};